import React, { useState } from 'react';
import { Modal } from 'antd';
import { encryption } from 'utils';
import { modalMethod } from 'components';
import { TableHeaderCell } from './menuStockDetailModal';
import { IMenuStockTemplate } from './types';
import { MenuStockManageBoardWrapper, MenuStockManageListWrapper } from './menuStockManageStyle';

const DETAIL_MODAL_HEADERS = [
  { label: '메뉴명', width: '40%' },
  { label: '금액', width: '27%' },
  { label: '판매상태', width: '16.5%' },
  { label: '재고수량', width: '16.5%' }
] as const;

interface IMenuTemplateEditModalProps {
  open: boolean;
  onClose: () => void;
  menuDetailModalData: IMenuStockTemplate;
  category: string[];
  onUpdateMenuStockTemplate: (params: any) => void;
}

const MenuTemplateEditModal = ({
  open,
  onClose,
  menuDetailModalData,
  category,
  onUpdateMenuStockTemplate
}: IMenuTemplateEditModalProps) => {
  const { menuStockItems } = menuDetailModalData;

  const [stockQuantities, setStockQuantities] = useState<Record<string, number | string>>({});

  const getInputValue = (menuId: string, originalStock: number | null | undefined) => {
    const userInput = stockQuantities[menuId];
    if (userInput !== undefined) return userInput;
    if (originalStock !== null && originalStock !== undefined) return originalStock;
    return '';
  };

  const handleStockInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, dataset } = e.target;
    const itemId = dataset.id;
    const numericValue = value === '' ? '' : parseInt(value, 10) || 0;

    setStockQuantities((prev) => ({
      ...prev,
      [itemId]: numericValue
    }));
  };

  const handleSaveStockQuantity = () => {
    const params = menuStockItems?.map((menu) => ({
      menuId: menu.menuId,
      stock: stockQuantities[menu.menuId] ?? menu.stock
    }));

    modalMethod.confirm(
      <>
        <div>재고 관리 템플릿을 수정하시겠습니까?</div>
        <div>이미 설정된 재고는 수정되지 않습니다.</div>
      </>,
      {
        okText: '확인',
        cancelText: '취소',
        cancelButtonProps: {
          style: { color: '#ff4d4f' }
        },
        zIndex: 10000,
        onOk: async () => {
          await onUpdateMenuStockTemplate({ menuStockItems: params });
          onClose();
        }
      }
    );
  };

  return (
    <Modal
      title="재고 관리 템플릿 수정"
      open={open}
      onCancel={onClose}
      footer={
        <div>
          <button type="button" className="btn btn-secondary" onClick={onClose} style={{ marginRight: '10px' }}>
            닫기
          </button>
          <button type="button" className="btn btn-success" onClick={handleSaveStockQuantity}>
            저장
          </button>
        </div>
      }
      width={1000}
      closable
      maskClosable={false}
      centered
    >
      <MenuStockManageListWrapper>
        <MenuStockManageBoardWrapper>
          <div style={{ marginBottom: '20px', marginLeft: '20px' }}>
            <div>* 템플릿 수정 시, 이미 설정된 재고는 수정되지 않습니다.</div>
            <div>* 재고수량 미입력 시, 무제한으로 판매 가능합니다.</div>
            <div>* 재고수량 0 입력 시, 사용자에게 &quot;일시품절&quot;로 노출됩니다.</div>
          </div>

          <div style={{ marginLeft: '20px' }}>검색 결과 : {menuStockItems.length} 건</div>

          <div className="ele2 menu-template-edit-modal-header">
            <table className="menu-header-table" style={{ marginTop: '10px' }}>
              <thead>
                <tr className="menu-table-header" style={{ width: '100%' }}>
                  {DETAIL_MODAL_HEADERS.map(({ label, width }) => (
                    <TableHeaderCell key={label} label={label} width={width} />
                  ))}
                </tr>
              </thead>
            </table>
          </div>

          <div className="scroll-box">
            <table
              className="menu-stockManage-table media-display-none"
              id="menu-stockManage-table"
              style={{ borderCollapse: 'collapse', marginTop: '-7px' }}
            >
              <tbody>
                {category &&
                  menuStockItems &&
                  category.map((name) => {
                    const categoryData = menuStockItems.filter((menu) => menu.category === name);
                    const { categoryId } = categoryData.length !== 0 ? categoryData[0] : { categoryId: '' };

                    return (
                      <React.Fragment key={(name as string) || 'etc'}>
                        <tr className={`category-row-${categoryId} menu-category`}>
                          <td className="media-display-none" colSpan={9}>
                            <div>
                              <span className="menu-group">{(name as string) || '기타'}</span>
                            </div>
                          </td>
                        </tr>

                        {categoryData &&
                          categoryData.map((data) => {
                            let status;
                            let fontColor = 'green';
                            if (data.status === 0) {
                              status = '판매종료';
                              fontColor = 'red';
                            } else if (data.status === 1) {
                              status = '판매중';
                              fontColor = 'green';
                            } else if (data.status === 2) {
                              status = '일시품절';
                              fontColor = 'orange';
                            } else if (data.status === 3) {
                              status = '재고부족';
                              fontColor = 'red';
                            }
                            return (
                              <tr key={data.menuId} className={data.status === 2 ? 'inactive_row' : undefined}>
                                <td className="media-display-none bgc-white menu-table-content" style={{ width: '22%' }}>
                                  {data.menuName}
                                </td>
                                <td className="media-display-none bgc-white menu-table-content" style={{ width: '15%' }}>
                                  {data.price ? `${encryption(data.price)}원` : '-'}
                                </td>
                                <td
                                  className="media-display-none bgc-white menu-table-content"
                                  style={{ width: '9%', color: fontColor }}
                                >
                                  {status}
                                </td>
                                <td className="media-display-none bgc-white menu-table-content" style={{ width: '9%' }}>
                                  <input
                                    type="number"
                                    min="0"
                                    value={getInputValue(data.menuId, data.stock)}
                                    onChange={(e) => handleStockInputChange(e)}
                                    data-id={data.menuId}
                                    className="form-control input-number"
                                    style={{ textAlign: 'center', fontSize: '16px' }}
                                    // disabled={isDateInPast || !(stockManageStatus[data.menuId] ?? data.isActiveMenuStockSetting)}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </MenuStockManageBoardWrapper>
      </MenuStockManageListWrapper>
    </Modal>
  );
};

export default MenuTemplateEditModal;
